import { render, staticRenderFns } from "./clueRecord.vue?vue&type=template&id=7898a65a"
import script from "./clueRecord.vue?vue&type=script&lang=js"
export * from "./clueRecord.vue?vue&type=script&lang=js"
import style0 from "./clueRecord.vue?vue&type=style&index=0&id=7898a65a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports